var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16q.425 0 .738-.312.312-.313.312-.738t-.312-.738Q12.425 13.9 12 13.9t-.737.312q-.313.313-.313.738t.313.738Q11.575 16 12 16Zm-.75-3.1h1.5q0-.475.038-.75.037-.275.112-.45.1-.2.288-.413.187-.212.612-.637.525-.525.788-1.05.262-.525.262-1.05 0-1.175-.775-1.862Q13.3 6 12 6q-1.025 0-1.8.575-.775.575-1.05 1.525l1.35.55q.175-.575.575-.888.4-.312.925-.312.6 0 .975.325t.375.825q0 .425-.187.737-.188.313-.663.713-.425.35-.675.638-.25.287-.375.562-.125.25-.162.613-.038.362-.038 1.037Zm.75 6.45q3.05-2.8 4.525-5.088Q18 11.975 18 10.2q0-2.725-1.738-4.463Q14.525 4 12 4 9.475 4 7.737 5.737 6 7.475 6 10.2q0 1.775 1.475 4.062Q8.95 16.55 12 19.35ZM12 22q-4.025-3.425-6.012-6.363Q4 12.7 4 10.2q0-3.75 2.413-5.975Q8.825 2 12 2t5.587 2.225Q20 6.45 20 10.2q0 2.5-1.987 5.437Q16.025 18.575 12 22Zm0-11.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressWarning);
export default __webpack_public_path__ + "static/media/address-warning.5d7d5d81546b5cadf8307e6cd8baba00.svg";
export { ForwardRef as ReactComponent };